import { Type } from '@sinclair/typebox';
import { SupportedNetwork } from '../supported-network.js';
import { TokenSocailsSchema } from './token-meta-extended.js';
import { TokenModerationStatus, TokenModerationStatusSchema, } from './token-moderation.js';
export const CommonTokenMetaSchema = Type.Object({
    address: Type.String(),
    name: Type.String(),
    symbol: Type.String(),
    decimals: Type.Number(),
    logo: Type.String(),
    supply: Type.String(),
    updatedAt: Type.String(),
    poolsSynced: Type.Optional(Type.Boolean()),
    burned: Type.String(),
    status: TokenModerationStatusSchema,
    socials: Type.Optional(TokenSocailsSchema),
    imageHash: Type.Optional(Type.String({
        description: 'Perceptual dHash of the token logo (64-bit hex)',
    })),
    reusedImageCount: Type.Optional(Type.Number({
        description: 'Number of other tokens sharing the same logo image',
    })),
});
export const SolTokenMetaSchema = Type.Object({
    ...CommonTokenMetaSchema.properties,
    network: Type.Literal(SupportedNetwork.Sol),
    uri: Type.Optional(Type.String()),
    mintAuthority: Type.String(),
    tokenProgram: Type.String(),
    freezeAuthority: Type.String(),
    updateAuthority: Type.String(),
    safetyCheck: Type.Boolean(),
    isRenounced: Type.Boolean(),
}, {
    title: 'SolTokenMeta',
    readOnly: true,
});
export const EvmTokenMetaSchema = Type.Object({
    ...CommonTokenMetaSchema.properties,
    network: Type.Union([
        Type.Literal(SupportedNetwork.Eth),
        Type.Literal(SupportedNetwork.Base),
        Type.Literal(SupportedNetwork.Bsc),
    ]),
}, {
    title: 'EthTokenMeta',
    readOnly: true,
});
export const TonTokenMetaSchema = Type.Object({
    ...CommonTokenMetaSchema.properties,
    network: Type.Literal(SupportedNetwork.Ton),
}, {
    title: 'TonTokenMeta',
    readOnly: true,
});
export const TokenMetaSchema = Type.Union([SolTokenMetaSchema, EvmTokenMetaSchema, TonTokenMetaSchema], { title: 'TokenMetaSchema' });
export const TokensMetaSchema = Type.Array(TokenMetaSchema, {
    title: 'TokensMetaSchema',
});
export const BASE_TOKENS_BY_NETWORK = {
    [SupportedNetwork.Sol]: {
        ['So11111111111111111111111111111111111111112']: {
            address: 'So11111111111111111111111111111111111111112',
            network: SupportedNetwork.Sol,
            symbol: 'SOL',
            name: 'Solana',
            decimals: 9,
            isRenounced: true,
            supply: '0',
            poolsSynced: true,
            logo: 'sol/native.png',
            tokenProgram: 'TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA',
            mintAuthority: 'So11111111111111111111111111111111111111112',
            freezeAuthority: 'So11111111111111111111111111111111111111112',
            updateAuthority: 'So11111111111111111111111111111111111111112',
            safetyCheck: true,
            status: TokenModerationStatus.Actve,
            updatedAt: new Date(0).toISOString(),
            burned: '0',
        },
        ['11111111111111111111111111111111']: {
            address: '11111111111111111111111111111111',
            network: SupportedNetwork.Sol,
            symbol: 'SOL',
            name: 'Solana',
            decimals: 9,
            isRenounced: true,
            supply: '0',
            poolsSynced: true,
            logo: 'sol/native.png',
            tokenProgram: '11111111111111111111111111111111',
            mintAuthority: 'So11111111111111111111111111111111111111112',
            freezeAuthority: 'So11111111111111111111111111111111111111112',
            updateAuthority: 'So11111111111111111111111111111111111111112',
            safetyCheck: true,
            status: TokenModerationStatus.Actve,
            updatedAt: new Date(0).toISOString(),
            burned: '0',
        },
        ['EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v']: {
            address: 'EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v',
            network: SupportedNetwork.Sol,
            symbol: 'USDC',
            name: 'USD Coin',
            decimals: 6,
            isRenounced: true,
            supply: '0',
            poolsSynced: true,
            logo: 'sol/usdc.png',
            tokenProgram: 'TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA',
            mintAuthority: 'None',
            freezeAuthority: 'None',
            updateAuthority: 'None',
            safetyCheck: true,
            status: TokenModerationStatus.Actve,
            updatedAt: new Date(0).toISOString(),
            burned: '0',
        },
        ['USD1ttGY1N17NEEHLmELoaybftRBUSErhqYiQzvEmuB']: {
            address: 'USD1ttGY1N17NEEHLmELoaybftRBUSErhqYiQzvEmuB',
            network: SupportedNetwork.Sol,
            symbol: 'USD1',
            name: 'USD1',
            decimals: 6,
            isRenounced: true,
            supply: '0',
            poolsSynced: true,
            logo: 'sol/usd1.png',
            tokenProgram: 'TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA',
            mintAuthority: 'None',
            freezeAuthority: 'None',
            updateAuthority: 'None',
            safetyCheck: true,
            status: TokenModerationStatus.Actve,
            updatedAt: new Date(0).toISOString(),
            burned: '0',
        },
        ['Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB']: {
            address: 'Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB',
            network: SupportedNetwork.Sol,
            symbol: 'USDT',
            name: 'USD Tether',
            decimals: 6,
            isRenounced: true,
            supply: '0',
            poolsSynced: true,
            logo: 'sol/usdt.png',
            tokenProgram: 'TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA',
            mintAuthority: 'None',
            freezeAuthority: 'None',
            updateAuthority: 'None',
            safetyCheck: true,
            status: TokenModerationStatus.Actve,
            updatedAt: new Date(0).toISOString(),
            burned: '0',
        },
    },
    [SupportedNetwork.Ton]: {
        ['EQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAM9c']: {
            address: 'EQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAM9c',
            network: SupportedNetwork.Ton,
            symbol: 'TON',
            name: 'Ton',
            logo: 'ton/native.png',
            decimals: 9,
            supply: '0',
            poolsSynced: true,
            isRenounced: true,
            status: TokenModerationStatus.Actve,
            updatedAt: new Date(0).toISOString(),
            burned: '0',
        },
    },
    [SupportedNetwork.Eth]: {
        ['0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2']: {
            address: '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2',
            network: SupportedNetwork.Eth,
            symbol: 'WETH',
            name: 'Wrapperd Ethereum',
            logo: 'eth/native.png',
            decimals: 18,
            supply: '0',
            poolsSynced: true,
            isRenounced: true,
            status: TokenModerationStatus.Actve,
            updatedAt: new Date(0).toISOString(),
            burned: '0',
        },
        ['0xdac17f958d2ee523a2206206994597c13d831ec7']: {
            address: '0xdac17f958d2ee523a2206206994597c13d831ec7',
            network: SupportedNetwork.Eth,
            symbol: 'USDT',
            name: 'Tether USD',
            logo: 'eth/usdt.png',
            decimals: 6,
            supply: '0',
            poolsSynced: true,
            isRenounced: true,
            status: TokenModerationStatus.Actve,
            updatedAt: new Date(0).toISOString(),
            burned: '0',
        },
        ['0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48']: {
            address: '0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48',
            network: SupportedNetwork.Eth,
            symbol: 'USDC',
            name: 'USD Coin',
            logo: 'eth/usdc.png',
            decimals: 6,
            supply: '0',
            poolsSynced: true,
            isRenounced: true,
            status: TokenModerationStatus.Actve,
            updatedAt: new Date(0).toISOString(),
            burned: '0',
        },
    },
    [SupportedNetwork.Base]: {
        ['0x4200000000000000000000000000000000000006']: {
            address: '0x4200000000000000000000000000000000000006',
            network: SupportedNetwork.Base,
            symbol: 'WETH',
            name: 'Wrapperd Ethereum',
            logo: 'base/native.png',
            decimals: 18,
            supply: '0',
            poolsSynced: true,
            isRenounced: true,
            status: TokenModerationStatus.Actve,
            updatedAt: new Date(0).toISOString(),
            burned: '0',
        },
    },
    [SupportedNetwork.Bsc]: {
        ['0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c']: {
            address: '0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c',
            network: SupportedNetwork.Bsc,
            symbol: 'WBNB',
            name: 'Wrapped BNB',
            logo: 'bsc/native.png',
            decimals: 18,
            supply: '0',
            uniswapVersion: 0,
            poolsSynced: true,
            isRenounced: true,
            status: TokenModerationStatus.Actve,
            updatedAt: new Date(0).toISOString(),
            burned: '0',
        },
        ['0x55d398326f99059ff775485246999027b3197955']: {
            address: '0x55d398326f99059ff775485246999027b3197955',
            network: SupportedNetwork.Bsc,
            symbol: 'USDT',
            name: 'Tether USD',
            logo: 'bsc/usdt.png',
            decimals: 18,
            supply: '0',
            uniswapVersion: 0,
            poolsSynced: true,
            isRenounced: true,
            status: TokenModerationStatus.Actve,
            updatedAt: new Date(0).toISOString(),
            burned: '0',
        },
        ['0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d']: {
            address: '0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d',
            network: SupportedNetwork.Bsc,
            symbol: 'USDC',
            name: 'USDC',
            logo: 'bsc/usdc.png',
            decimals: 18,
            supply: '0',
            poolsSynced: true,
            isRenounced: true,
            status: TokenModerationStatus.Actve,
            updatedAt: new Date(0).toISOString(),
            burned: '0',
        },
    },
};
export const BASE_TOKEN_ADDRESSES_BY_NETWORK = Object.keys(BASE_TOKENS_BY_NETWORK).reduce((accumulator, network) => {
    accumulator[network] = new Set(Object.values(BASE_TOKENS_BY_NETWORK[network]).map((token) => token.address));
    return accumulator;
}, {});
export const getBaseTokenByAddress = (network, address) => {
    const baseToken = BASE_TOKENS_BY_NETWORK[network][address];
    if (!baseToken) {
        throw new Error(`Base token not found for ${network} ${address}`);
    }
    return baseToken;
};
export const NATIVE_TOKEN_ADDRESSES_BY_NETWORK = {
    [SupportedNetwork.Sol]: new Set([
        'So11111111111111111111111111111111111111112',
        '11111111111111111111111111111111',
    ]),
    [SupportedNetwork.Ton]: new Set([
        'EQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAM9c',
    ]),
    [SupportedNetwork.Eth]: new Set([
        '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2',
    ]),
    [SupportedNetwork.Base]: new Set([
        '0x4200000000000000000000000000000000000006',
    ]),
    [SupportedNetwork.Bsc]: new Set([
        '0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c',
    ]),
};
//# sourceMappingURL=token-meta.js.map